import type { App } from 'vue'
import installVantComponents from './vantComponents'
import { ButtonCompat, PopupCompat, RadioCompat, FieldCompat, CheckboxCompat } from './compat'
import 'vant/lib/index.css'
import './styles/vant-theme.less'
export * from 'vant'
export * from './compat'
export * from './resolver'
export { ButtonCompat, PopupCompat, RadioCompat, FieldCompat, CheckboxCompat }

export default function install(app: App): void {
  installVantComponents(app)
}
